<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Abonos {{ modelValue.cliente.descripcion }}</h3>
      </div>
    </div>
    <div class="table-responsive">
      <table>
        <thead>
          <tr>
            <th>Cuota</th>
            <th>Valor</th>
            <th>Total pagado</th>
            <th>Valor a pagar</th>
            <th>Saldo</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="modelValue.pago.cuotas.length > 0">
            <tr
              v-for="(amortizacion, index) in modelValue.pago.cuotas"
              :key="amortizacion.cuota"
              :index="index"
              is="tr-cuota"
              @selectCuotasInferiores="seleccionarCtMen(index)"
              v-model="modelValue.pago.cuotas[index]"
            ></tr>
          </template>
          <tr v-else>
            <td colspan="4">No existen datos.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <!-- v-model="form.total" -->
          <input-field
            stretch
            vMoney
            :format="money"
            readonly
            id="total"
            placeholder="##.##"
            :value="calcular"
          >
            <span>Total</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            stretch
            vMoney
            :format="money"
            readonly
            id="saldo_total"
            placeholder="##.##"
            v-model="modelValue.pago.amt_total_saldo"
          >
            <span>Saldo total</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            stretch
            vMoney
            :format="money"
            readonly
            id="total_pagar"
            placeholder="##.##"
            v-model="modelValue.pago.amt_total_a_pagar"
          >
            <span>A pagar</span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button class="btn-success" @click="abrirModalPago">
        <i class="fa fa-save"></i><span>Aceptar</span>
      </button>
      <button class="btn-danger btn--text" @click="$emit('cerrar')">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
    <modal
      name="modalComprobantePago"
      scrollable
      reset
      adaptive
      resizable
      height="auto"
      width="50%"
      clickToClose
    >
      <modal-amt-pago
        :fecha-ruta-cobro="fechaRutaCobro"
        v-model="modelValue"
        @input="abonar"
        @cerrar="$modal.hide('modalComprobantePago')"
      >
      </modal-amt-pago>
    </modal>
  </div>
</template>

<script>
import TrCuota from "./TrCuota.vue";
import ModalAmtPago from "./ModalAmtPago.vue";
export default {
  components: { TrCuota, ModalAmtPago },
  props: {
    value: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    fechaRutaCobro: {
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      modelValue: JSON.parse(JSON.stringify(this.value)),
      money: money,
    };
  },
  methods: {
    abrirModalPago: function () {
      if (!this.modelValue.pago.editar) {
        this.modelValue.pago.valor = 0;
        this.modelValue.pago.efectivo = 0;
        this.modelValue.pago.transferencia = 0;
        this.modelValue.pago.deposito = 0;
        this.modelValue.pago.ref_deposito = "";
        this.modelValue.pago.archivo = null;
        this.modelValue.pago.url_archivo = null;
        this.modelValue.pago.observaciones = "";
      }
      this.$modal.show("modalComprobantePago");
    },
    abonar: function () {
      this.modelValue.pago.editar = true;
      this.$modal.hide("modalComprobantePago");
      this.$emit("input", this.modelValue);
    },
    cargarDatos: function () {
      axios
        .get(
          url +
            "/rutas-cobros/cargar-cuotas/" +
            this.modelValue.cliente_ruta_cobro_id
        )
        .then(({ data }) => {
          this.modelValue.pago.cuotas.splice(
            0,
            this.modelValue.pago.cuotas.length
          );
          const { crc, cuotas } = data;
          this.modelValue.cuotas_canceladas = crc.cuotas_canceladas;
          this.modelValue.cuotas_faltantes = crc.cuotas_faltantes;
          this.modelValue.atrasos = crc.atrasos;
          this.modelValue.estado = crc.estado;
          this.modelValue.total_pagado = crc.total_pagado;
          this.modelValue.saldo = round(
            crc.prestamo.total - crc.total_pagado,
            2
          );
          this.modelValue.valor_cuota = crc.prestamo.cuota_actual ? crc.prestamo.cuota_actual.valor : crc.prestamo.ultima_cuota.valor;
          cuotas.forEach((item) => {
            if (crc.pago) {
              item["total_pagado"] = item.abono_id
                ? parseFloat(item.total_pagado) - parseFloat(item.valor_abono)
                : parseFloat(item.total_pagado);
              item["seleccionada"] = item.abono_id != null;
              item["valor_pago"] = item.valor_abono || 0.0;
            } else {
              item["seleccionada"] = false;
              item["valor_pago"] = 0.0;
            }
            this.modelValue.pago.cuotas.push(item);
          });
        })
        .catch((error) => {
          console.error(error);
          swal("Hubo un error al cargar los datos.", "Error", "error");
        });
    },
    seleccionarCtMen: function (index) {
      for (let i = 0; i < index; i++) {
        const element = this.modelValue.pago.cuotas[i];
        element.seleccionada = true;
        element.valor_pago = round(parseFloat(element.valor) - parseFloat(element.total_pagado), 2);
      }
    }
  },
  computed: {
    calcular: function () {
      let total = 0;
      let total_saldo = 0;
      let total_a_pagar = 0;
      this.modelValue.pago.cuotas
        .filter((item) => item.seleccionada)
        .map((item) => {
          let valor = parseFloat(item.valor);
          if (isNaN(valor)) valor = 0;
          let valor_pago = parseFloat(item.valor_pago);
          if (isNaN(valor_pago)) valor_pago = 0;
          let saldo = parseFloat(item.saldo);
          if (isNaN(saldo)) saldo = 0;
          total += valor;
          total_saldo += saldo;
          total_a_pagar += valor_pago;
        });
      this.modelValue.pago.amt_total = round(total, 2);
      this.modelValue.pago.amt_total_saldo = round(total_saldo, 2);
      this.modelValue.pago.amt_total_a_pagar = round(total_a_pagar, 2);

      return total;
    },
  },
  mounted: function () {
    this.cargarDatos();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/cobros/modalAbono.vue